<div class="gb-message-container flex-col flex-justify-space-between">
  <div class="flex-row flex-justify-end flex-align-start">
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <div class="gb-message-content-container flex-col-center" [ngSwitch]="messageType">
    <div *ngSwitchCase="'success'">
      <div class="flex-col-center">
        <div *ngIf="item" [ngSwitch]="item.item_type">
          <div class="message-dialog-animation-container">
            <gb-bid-success-animation *ngSwitchCase="itemTypeEnum.Bidding"></gb-bid-success-animation>
            <gb-raffle-success-animation *ngSwitchCase="itemTypeEnum.Raffle"></gb-raffle-success-animation>
            <gb-donation-success-animation *ngSwitchCase="itemTypeEnum.Donation"></gb-donation-success-animation>
            <gb-purchase-success-animation *ngSwitchCase="itemTypeEnum.Purchase"></gb-purchase-success-animation>
          </div>
        </div>
        <div *ngIf="eventTicket" class="message-dialog-animation-container">
          <gb-ticket-success-animation></gb-ticket-success-animation>
        </div>
        <div *ngIf="!item && !eventTicket && payment" class="message-dialog-animation-container">
          <gb-payment-success-animation> </gb-payment-success-animation>
        </div>
        <div *ngIf="!item && !payment && !eventTicket" class="message-dialog-animation-container">
          <span class="material-icons">emoji_emotions</span>
        </div>
      </div>
    </div>

    <div class="message-dialog-animation-container" *ngSwitchCase="'warning'">
      <gb-error-animation></gb-error-animation>
    </div>

    <span *ngSwitchCase="'message'" class="material-icons"> chat_bubble </span>
    <div class="gb-message-content">
      <h2 mat-dialog-title [translate]="title"></h2>

      <mat-dialog-content>
        <h3 class="message-body" [translate]="body"></h3>
      </mat-dialog-content>
    </div>
  </div>

  <ng-container *ngIf="auction$ | async as auction">
    <div class="flex-col flex-justify-space-between">
      <div *ngIf="auction.enable_activity_feed && activityFeed && item" class="activity-feed-container">
        <mat-card>
          <mat-card-content>
            <gb-activity-feed-post-create [item]="item"> </gb-activity-feed-post-create>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="button-container flex-col px-gap-10">
        <button mat-raised-button color="primary" mat-dialog-close>
          <span [translate]="getCloseButtonLabel(auction)"></span>
        </button>
        <button
          *ngIf="eventTicket"
          mat-stroked-button
          color="primary"
          mat-dialog-close
          (click)="navigateToEventTickets(auction)"
        >
          <span translate="EVENT_TICKET.MANAGE_TICKETS_BUTTON_LABEL"></span>
        </button>
      </div>
    </div>
  </ng-container>
</div>
